import axios from 'axios';
import { push } from "connected-react-router";
import * as React from 'react';
import { SpinnerComponent } from 'react-element-spinner';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { toastr } from "react-redux-toastr";
import { Button, FormGroup, Input, Label } from "reactstrap";
import { DictlanguagesOptions } from '../Helpers/DataHelpers';
import { GetCompanyDataResult, LoadCompanyLogoResult, LoginClientResponse, translationType } from '../Interfaces/Interfaces';
import { Login, Logout } from '../redux/actions/AuthActions';
import { ChangeLanguage } from '../redux/actions/languageAction';
import * as ReduxTypes from "../redux/constants";
import { IUserData } from '../redux/constants';

declare var require: any;
const queryString = require('querystring');
const YoonitSystem = require("../Assets/imgs/YoonitSystem.svg") as string;
const Yoonit = require("../Assets/imgs/Yoonit.svg") as string;
const plugit = require("../Assets/imgs/plugit.svg") as string;

interface IProps {
    isServiceTicket?: boolean;
    Logout: any;
    Login: any;
    ChangeLanguage: any;
    UpdateLanguage: any;
    lang: translationType;
    i18n: any;
    t: any;
    router: any;
    push: any;
    theme: any;
    userData: IUserData;
    AddNewMessage: any;
    PushNotificationSettings: any;
    PushNotification: any;
    UpdateDashboard: any;
    UpdateCompanySettings: any;
    SetSignalR: any;
    IsEnabled: any;
    IsEnabledDESCRIPTION: any;
    isAuth: boolean;
    isTokenExpired: boolean;
    isTokenValid: boolean;
    CompanyDataProps: GetCompanyDataResult;
    CompanySettings: LoadCompanyLogoResult;
    LangselectedOption: ReduxTypes.LanguageOption;
}
interface IState {
    username: string;
    password: string;
    languageChosen: translationType;
    isLoading: boolean;
    headerTitle: string;
    imagesSrc: string;
    imgDesc: string;
    circular: boolean;
    picture: string
    openAccType: boolean;
    GetCompanyDataResult: GetCompanyDataResult;
    userData: IUserData;
    loginResponse: any;
    LightLogo: string;
    DarkLogo: string;
    IsCircular: boolean;
    GetURL: string;
    ActionURL: string;
    TokenFromQueryString: string;
}
const mapStateToProps = (state: ReduxTypes.IStore) => ({
    userData: state.auth.UserData,
    lang: state.language.lang,
    router: state.router,
    theme: state.theme,
    isAuth: state.auth.isAuth,
    isTokenExpired: state.auth.isTokenExpired,
    isTokenValid: state.auth.isTokenValid,
    CompanyDataProps: state.CompanyData,
    CompanySettings: state.CompanySettings,
    LangselectedOption: state.language,
});
const dispatchProps = { push, Login, Logout, ChangeLanguage };
class SignIn extends React.PureComponent<any, IState> {
    constructor(props: any) {
        super(props);
        this.state = {
            username: '',
            password: '',
            languageChosen: 'en',
            isLoading: false,
            headerTitle: '',
            imagesSrc: "",
            imgDesc: "",
            circular: false,
            picture: '',
            openAccType: false,
            GetCompanyDataResult: new GetCompanyDataResult(),
            userData: {
                id: "",
                Token: "",
                RefreshToken: "",
                isAdmin: false,
                isFirstUser: false,
                yoonitGetURL: "",
                yoonitActionURL: "",
                TechAPIURL: "",
                CDNURL: "",
                UserName: "",
                Language: "en",
                TimeZone: 0,
                ZendeskID: ''
            },
            loginResponse: {} as any,
            LightLogo: '',
            DarkLogo: '',
            IsCircular: false,
            GetURL: "https://uat-get-yoonit.azurewebsites.net/api/",
            ActionURL: "https://uat-actions-yoonit.azurewebsites.net/api/",
            TokenFromQueryString: "",
        };

    }

    componentDidMount() {

        this.props.Logout();
        localStorage.clear();
        this.GetCompanyData();
        if (!this.props.isServiceTicket) {
            try {
                let values = queryString.parse(this.props.location.search);
                if (values && values[Object.keys(values)[0]]) {
                    let Token = values[Object.keys(values)[0]];
                    this.setState({ TokenFromQueryString: Token }, () => this.handleSubmit({}, true))
                }
            } catch (e) {
                console.error('queryString: ', e);
            }
        }
        document.documentElement.setAttribute('lang', this.props.LangselectedOption.value);
        this.onLanguageChange(this.props.LangselectedOption.value);
        if (this.props.LangselectedOption.value === "ar") {
            document.documentElement.setAttribute('dir', "rtl");
        }
        else {
            document.documentElement.setAttribute('dir', "ltr");
        }
    }
    handleChange = (e: any) => {
        this.setState({ [e.target.name]: e.target.value } as any);
    };
    GetCompanyData = () => {
        this.setState({
            GetCompanyDataResult: this.props.CompanySettings,
            GetURL: this.props.CompanySettings.YoonitGetURL,
            ActionURL: this.props.CompanySettings.YoonitActionURL,
        }, this.LoadCompanyLogo);

    }
    LoadCompanyLogo = () => {
        this.setState({
            LightLogo: this.props.CompanySettings.LightLogo,
            DarkLogo: this.props.CompanySettings.DarkLogo,
            IsCircular: this.props.CompanySettings.IsCircular
        });
    }

    handleSubmit = async (e: any, LoginByToken?: true) => {
        var data: any;
        if (!LoginByToken) {
            e.preventDefault();
            e.persist();

            data = {
                Username: this.state.username,
                Password: btoa(this.state.password)
            };
            if (!this.state.username || !this.state.password) {
                this.setState({ isLoading: false });
                toastr.warning('', this.props.t('FillFields'));
            }
        } else {
            data = {
                Token: this.state.TokenFromQueryString,
            };
        }
        this.setState({ isLoading: true });
        const res = await axios.post<LoginClientResponse>(`api/Auth/${LoginByToken ? 'LoginByToken' : 'LoginClient'}`, data); // add interface 
        if (res.data.isAuth === true) {
            //if (res && res.data && res.data.CompanyData) {
            //    store.dispatch(UpdateCompanyData(res.data.CompanyData ? res.data.CompanyData : new GetCompanyDataResult()));
            //}
            this.props.Login(res.data);
            if (!!this.props.isServiceTicket) {
                //window.location.replace(this.props.ServiceTicketURL);
            }
            else {
                this.props.push("/Documentation");
            }
            //this.props.Login(res.data);

        }
        else {
            this.setState({
                isLoading: false,
                password: ""
            });
            toastr.warning('', this.props.t('InvalidCredentials'));
        }

    }

    onLanguageChange = (selectedLanguage: any) => {
        this.props.ChangeLanguage(DictlanguagesOptions[selectedLanguage]);
        this.props.i18n.changeLanguage(selectedLanguage);
        document.documentElement.setAttribute('lang', selectedLanguage.value);
        if (selectedLanguage === "ar") {
            document.documentElement.setAttribute('dir', "rtl");
        }
        else {
            document.documentElement.setAttribute('dir', "ltr");
        }

    }
    handleSubmitTemp = () => {
        this.props.push("/Documentation")

    }
    public render() {
        return (
            <div className=" mainExternal signin heightSighnIn" >
                <SpinnerComponent loading={this.state.isLoading} position="inline" color="#00ad0f" />
                {!this.state.isLoading && <div className={this.state.isLoading ? "blurBackground " : ""}>
                    <div className="container mt80 py-5 align-items-center">
                        <div className="row b-white">
                            <div className="col-md-5 col-lg-5 p-0 m-0">
                                <form action="#" className="newExternalForm2" onSubmit={(e: any) => this.handleSubmit(e)}>
                                    <div className="insidenewExternalForm2">
                                        <img src={Yoonit} alt="" className="h46 " />
                                        <div >
                                            <Label className="signupText mt-1 mb-1 font-18 " > {this.props.t('Login')} </Label>

                                        </div>

                                        <FormGroup>
                                            <Label className="text-Grey font-12" >{this.props.t('Email')}</Label>
                                            <Input
                                                bsSize="lg"
                                                name="username"
                                                id="email"
                                                value={this.state.username}
                                                onChange={this.handleChange}
                                                tabIndex={1}
                                                className="InputsExternal"
                                            />
                                        </FormGroup>
                                        <FormGroup>
                                            <Label className="text-Grey font-12" >{this.props.t('Password')}</Label>
                                            <Input
                                                className="InputsExternal"
                                                type="password"
                                                name="password"
                                                id="password"
                                                bsSize="lg"
                                                value={this.state.password}
                                                onChange={this.handleChange}
                                                tabIndex={2}
                                            />
                                        </FormGroup>
                                        <div className="text-center mb-1 paddingtop">
                                            <Button md={6} className="fluid-width fw600 loginBtn " size="sm">
                                                {this.props.t(this.props.isServiceTicket?'Login to Continue':'Login')}
                                            </Button>
                                        </div>
                                    </div>
                                </form>

                            </div>
                            <div className="col-md-7 col-lg-7 hideDivImage p-0 m-0">
                                <img src={YoonitSystem} alt="" className="h70vh w100p fitObject" />
                            </div>
                        </div>
                    </div>
                    <div className="footerExternal">
                        <Label className="text-Grey font-16" >v1.0.0 </Label> <Label className="text-Grey font-30 mr-2 ml-2 mt-2"> | </Label> <Label className="text-Grey font-16"> Powered by </Label> <img src={plugit} alt="" className="h25 ml-3" />
                    </div>
                </div>
                }
            </div>
        );
    }
};

export default withTranslation()(connect(mapStateToProps, dispatchProps)(SignIn));
